"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessInvitationStatusToJSON = exports.BusinessInvitationStatusFromJSONTyped = exports.BusinessInvitationStatusFromJSON = exports.BusinessInvitationStatus = void 0;
/**
 * Status of a user's permission to a business
 * @export
 */
exports.BusinessInvitationStatus = {
    Accepted: 'ACCEPTED',
    Pending: 'PENDING',
    Cancelled: 'CANCELLED'
};
function BusinessInvitationStatusFromJSON(json) {
    return BusinessInvitationStatusFromJSONTyped(json, false);
}
exports.BusinessInvitationStatusFromJSON = BusinessInvitationStatusFromJSON;
function BusinessInvitationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BusinessInvitationStatusFromJSONTyped = BusinessInvitationStatusFromJSONTyped;
function BusinessInvitationStatusToJSON(value) {
    return value;
}
exports.BusinessInvitationStatusToJSON = BusinessInvitationStatusToJSON;
